<template>
  <header-middle></header-middle>
  <information-template></information-template>
  <map-ifram></map-ifram>
  <message-popup></message-popup>
  <grid-template></grid-template>
  <footer-template></footer-template>
</template>

<script>
import HeaderMiddle from '../section/header/header.vue'
import GridTemplate from "../section/footer/grids.vue";
import FooterTemplate from "../section/footer/footer.vue";
import InformationTemplate from "../section/pages/Contact/information.vue";
import MapIfram from "../section/pages/Contact/map.vue";
import MessagePopup from "../section/pages/Contact/message.vue";
export default {
components:
{
    HeaderMiddle,GridTemplate,FooterTemplate,InformationTemplate,MapIfram,MessagePopup
},
name:"ContactPage",
}
</script>

<style>

</style>